import React from 'react';
import PropTypes from 'prop-types';
import { maxBy } from 'lodash';
import RelativesTable from './RelativesTable';
import RelativesTableDisclaimer from './RelativesTableDisclaimer';

const FlatJumpsTables = ({
    data: { FLAT, JUMPS },
    disclaimerName,
    flatTitle,
    jumpsTitle,
    flatNoData,
    jumpsNoData,
}) => {
    const flatJumps = [
        { type: 'Flat', data: FLAT, noDataText: flatNoData, title: flatTitle },
        { type: 'jumps', data: JUMPS, noDataText: jumpsNoData, title: jumpsTitle },
    ];
    const maxFlat = maxBy(FLAT, 'bestRpPostmark');
    const maxJumps = maxBy(JUMPS, 'bestRpPostmark');

    if (maxJumps && (!maxFlat || (maxFlat.bestRpPostmark < maxJumps.bestRpPostmark))) {
        flatJumps.reverse();
    }

    return (
        <div>
            {flatJumps.map(({ type, data, noDataText, title }) => (
                <RelativesTable
                    key={type}
                    data={data}
                    noDataText={noDataText}
                    title={title}
                />
            ))}
            <RelativesTableDisclaimer type={disclaimerName} />
        </div>
    );
};

FlatJumpsTables.propTypes = {
    disclaimerName: PropTypes.string,
    flatTitle: PropTypes.string,
    jumpsTitle: PropTypes.string,
    flatNoData: PropTypes.string,
    jumpsNoData: PropTypes.string,
    data: PropTypes.shape({
        FLAT: PropTypes.arrayOf(PropTypes.shape({ horseUid: PropTypes.number })),
        JUMPS: PropTypes.arrayOf(PropTypes.shape({ horseUid: PropTypes.number })),
    }).isRequired,
};

export default FlatJumpsTables;



// WEBPACK FOOTER //
// ./src/js/horse/pedigree/relativesTable/FlatJumpsTables.jsx